<template>
  <div class="content">
    <div class="lineBox" style="border:0px;">
      <div class="h3" @click="backToProducts()" style="float:left;margin-top:5px;cursor:pointer;">
        <font-awesome-icon style="font-siz:20px;color:#ffffff;" :icon="['fal', 'chevron-circle-left']"/>
        Produtos
      </div>
    </div>
    <div class="line">
      <div v-if="!id" class="adicionar-produto">Adicionar Produto</div>
      <div v-else class="adicionar-produto">Editar produto</div>
    </div>
    <div class="line" style="border-bottom:1px solid #706C7A;"></div>
    <div class="line">
      <div class="col6">
        <div class="line">
          <div class="inputLabel">Nome</div>
          <input type="text" class="inputWire" style="width:100%" v-model="product.name"/>
        </div>
        <div class="line">
          <div class="inputLabel">SKU</div>
          <input type="text" class="inputWire" style="width:100%" v-model="product.product_views[0].sku"/>
        </div>
        <div class="line">
          <div class="inputLabel">EAN</div>
          <input type="text" class="inputWire" style="width:100%" v-model="product.product_views[0].ean"/>
        </div>
        <div class="line">
          <div class="inputLabel">Descrição</div>
          <template v-if="!loadingProduct">
            <VueTrix inputId="description" v-model="product.description"/>
          </template>
        </div>
        <div class="line">
          <div class="inputLabel">Imagem</div>
          <div class="wire" style="padding:10px; min-height:100px; position:relative">
            <img v-if="getImage() !== null" :src="getImage()" style="width:300px;"/>
            <label for="selecao-arquivo">Enviar Imagem</label>
            <input id="selecao-arquivo" @change="uploadImage($event)" type="file"/>
          </div>
        </div>
      </div>
      <div class="col6">
        <div class="line">
          <div class="inputLabel">Preço</div>
          <input type="number" class="inputWire" style="width:15%" v-model.number="product.product_views[0].price"/>
        </div>
        <div class="line">
          <div class="inputLabel">Preço Promocionado</div>
          <input type="number" class="inputWire" style="width:15%" v-model.number="product.product_views[0].promotional_price"/>
        </div>
        <div class="line">
          <div class="inputLabel">Lista de Opções</div>
          <button style="margin-bottom: 5px" @click="plusOptions(product)">Nova Lista de Opções</button>
          <table v-for="(option, idxo) in product.options" v-bind:key="idxo" style="border:1px; width:100%; margin-bottom: 16px" border="1" cellpadding="5">
            <tr style="">
              <td colspan="4">{{idxo+1}}º Lista de Opções</td>
              <td colspan="1" style="border: none">
                <font-awesome-icon @click="removeOption(product, option)" style="font-size:22px;color:#bb3f5c;margin:5px;" :icon="['fal', 'trash-alt']"/>
              </td>
            </tr>
            <tr>
              <td colspan="1">Título:</td>
              <td colspan="3">
                <input required placeholder="Digite o nome da lista de opções Ex: Tamanho da Pizza" style="width: 100%" v-model="option.label">
              </td>
            </tr>
            <tr>
              <td>Mínimo:</td>
              <td>
                <input required type="number" min="0" v-model.number="option.min">
              </td>
              <td>Máximo:</td>
              <td>
                <input required type="number" min="1" v-model.number="option.max">
              </td>
            </tr>
            <tr>
              <td>Ativo:</td>
              <td align="center">
                <template v-if="option.active === true">
                  <img src="img/on.png" @click="activeInativeOption(option, false)" style="cursor:pointer;"/>
                </template>
                <template v-else>
                  <img src="img/off.png" @click="activeInativeOption(option, true)" style="cursor:pointer;"/>
                </template>
              </td>
              <td>Ordenação:</td>
              <td>
                <input type="number" v-model.number="option.order">
              </td>
            </tr>
            <tr>
              <td colspan="2">Opções da Lista:</td>
              <td colspan="2" align="center">
                <button @click="plusChoices(option)">Nova Opção</button>
              </td>
            </tr>
            <tr v-for="(choice, idxc) in option.choices" v-bind:key="idxc">
              <td colspan="4">
                <table style="border:1px border-collapse:collapse;width:100%;" border="1" cellpadding="5">
                  <tr>
                    <td colspan="1">Item:</td>
                    <td colspan="3">
                      <input required placeholder="Digite o nome da opção. Ex: Grande" style="width: 100%" v-model="choice.label">
                    </td>
                  </tr>
                  <tr>
                    <td>Valor Adicional</td>
                    <td colspan="3">
                      <input required type="number" placeholder="Digite o Preço adicional. Ex: 0,00" style="width: 100%" v-model.number="choice.price">
                    </td>
                  </tr>
                  <tr>
                    <td colspan="1">Ativo:</td>
                    <td colspan="1" align="center">
                      <template v-if="choice.active === true">
                        <img src="img/on.png" @click="activeInativeChoice(choice, false)" style="cursor:pointer;"/>
                      </template>
                      <template v-else>
                        <img src="img/off.png" @click="activeInativeChoice(choice, true)" style="cursor:pointer;"/>
                      </template>
                    </td>
                    <td colspan="1">Excluir:</td>
                    <td align="center" colspan="1">
                      <font-awesome-icon @click="removeChoice(option, choice)" style="font-size:22px;color:#bb3f5c;margin:5px;" :icon="['fal', 'trash-alt']"/>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div class="line" style="padding-bottom:40px;">
          <button class="buttonWire" style="float:left;margin:10px;width:45%;" @click="$router.push({path:'/products'})">Voltar</button>
          <button style="float:right;margin:10px;width:45%;" @click="saveProduct(false, true)">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import VueTrix from 'vue-trix'
  import {mapGetters} from 'vuex'
  import {EventBus} from '@/utils/event-bus'
  import formater from '@/mixins/formater'
  import productMixin from "../mixins/productMixin"

  export default {
    name: 'Product',

    data() {
      return {
        loadingProduct: true,
        id: null,
        product: {
          category_id: "0",
          name: null,
          description: null,
          active: true,
          photos: [{
            id: null,
            name: null,
            order: 0
          }],
          has_presentation: false,
          presentations: [],
          company_id: null,
          product_views: [{
            id: null,
            name: null,
            order: 0,
            stock_quantity: null,
            view: [],
            sku: null,
            ean: null,
            price_cost: 0,
            price: 0,
            promotional_price: 0,
            active: true,
            height: null,
            weight: null,
            width: null,
            photos: [],
            unit_label: null,
            unit_quantity: 0
          }],
          options: []
        },
        global: {},
        enablePresentations: false,
      }
    },

    mixins: [formater, productMixin],

    components: {
      VueTrix
    },

    created() {
      if (this.$route.params.productId && this.$route.params.productId !== '0') {
        this.id = this.$route.params.productId
        this.getProductById(this.id)
      } else {
        console.log('not will log')
        this.loadingProduct = false
      }
    },

    computed: {
      ...mapGetters(['getProductApi', 'getOpaApi']),
    },

    methods: {
      ...mapGetters(['getCompany']),

      plusOptions(product) {
        if (!product.options) {
          product.options = []
        }
        product.options.push({
          "label": null,
          "min": 0,
          "max": 1,
          "choices": [{
            "label": null,
            "active": true
          }],
          "order": 0,
          "active": true
        })
        this.$forceUpdate()
      },

      removeOption(product, option) {
        product.options = product.options.filter(o => o !== option)
        this.$forceUpdate()
      },

      activeInativeOption(option, action) {
        option.active = action
      },

      plusChoices(option) {
        if (!option.choices) {
          option.choices = []
        }
        option.choices.push({
          "label": null,
          "active": true
        })
        this.$forceUpdate()
      },

      removeChoice(option, choice) {
        option.choices = option.choices.filter(c => c !== choice)
        this.$forceUpdate()
      },

      activeInativeChoice(choice, action) {
        choice.active = action
      },

      validateProductViews() {
        let valid = true
        for (let x = 0; x < this.product.product_views.length; x++) {

          if (!this.product.product_views[x].name || !this.product.product_views[x].name.length) {
            valid = false
            EventBus.$emit('showAlert', 'error', 'Necessário inserir um Nome do Produto')
            break
          }
          if (!this.product.product_views[x].order.toString().length) {
            valid = false
            EventBus.$emit('showAlert', 'error', 'Campo ordem é obrigatório')
            break
          }
          if (!this.product.product_views[x].stock_quantity.toString().length) {
            valid = false
            EventBus.$emit('showAlert', 'error', 'Campo estoque é obrigatório')
            break
          }
          if (!this.product.product_views[x].price) {
            valid = false
            EventBus.$emit('showAlert', 'error', 'Campo preço é obrigatório e deve ser maior que 0')
            break
          }
        }
        return valid
      },

      validateChoices(choices, isOptionActive, optionIndex) {
        let valid = true
        for (let [position, choice] of choices.entries()) {
          if (!choice.label || !choice.label.length) {
            EventBus.$emit('showAlert', 'error', `Nome do  ${position}º item na ${optionIndex + 1}ª opção é obrigatório`)
            valid = false
            break
          }
        }
        if (valid && isOptionActive) {
          valid = this.validateAllChoicesActive(choices, optionIndex)
        }
        return valid
      },

      validateAllChoicesActive(choices, optionIndex) {
        let valid = true
        let result = choices.filter(choice => !choice.active)
        if (choices.length === result.length) {
          EventBus.$emit('showAlert', 'error', 'Todas as opções da lista ' + [optionIndex + 1] + 'ª estão desativadas, ative alguma opção ou desative a lista')
          valid = false
        }
        return valid
      },
    }
  }
</script>
<style lang="scss" scoped>
  .adicionar-produto {
    color: #12FCC4;
    font-family: Roboto;
    font-size: 18px;
    font-weight: 500;
    line-height: 18px;
  }

  .inputLabel {
    color: #FFFFFF;
    font-family: Roboto;
    font-size: 14px;
    margin-bottom: 10px;
  }

  /* Esconde o input */

  input[type='file'] {
    display: none;
  }

  label {
    width: 120px;
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
    text-decoration: underline;
    color: #12FCC4;
    font-family: Roboto;
    font-size: 14px;
  }
</style>
